import html2pdf from "html2pdf.js";

/**
 * Generates a PDF Blob from a DOM element using html2pdf.js.
 * Uses A4 portrait, scale 2 for crisp rendering, with smart page breaks.
 */
export async function generatePdfBlob(element, filename = "document.pdf") {
  if (!element) throw new Error("Elemento alvo para PDF não encontrado");

  const options = {
    margin: [8, 8, 8, 8],
    filename,
    image: { type: "jpeg", quality: 0.95 },
    html2canvas: {
      scale: 2,
      useCORS: true,
      backgroundColor: "#ffffff",
      logging: false,
      // Render the inner iframe's window context properly
      windowWidth: element.scrollWidth,
    },
    jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
    pagebreak: { mode: ["css", "legacy"], avoid: [".print-card", "tr", ".avoid-break"] },
  };

  const blob = await html2pdf().set(options).from(element).output("blob");
  return blob;
}
